import {formQueryString, getUrlParameter} from '@js/helpers/location';

export function refreshRankingPage(appendCompareOrganizationParams = true, queryParams = null) {
    window.location.search = getRefreshRankingPageParams(appendCompareOrganizationParams, queryParams);
}

export function getRefreshRankingPageParams(appendCompareOrganizationParams = true, queryParams = null) {
    const form = ($('#modal-filters').css('display') === 'block') ? 'modal-filter-form' : 'filters'
    const queryString = queryParams || $(`form#${form}`).serialize();
    const params = [queryString];
    if (appendCompareOrganizationParams) {
        const compareOrganizationsInUrl = getUrlParameter('organizations');
        if (compareOrganizationsInUrl && compareOrganizationsInUrl.length) {
            params.push(formQueryString({organizations: compareOrganizationsInUrl}));
        }
    }
    const $modeForm = $('#mode-form');
    if ($modeForm.length) {
        params.push($modeForm.serialize());
    }
    const $sortForm = $('#sort');
    if ($sortForm.length) {
        params.push($sortForm.serialize());
    }
    return params.join('&');
}
